import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { BlogCard } from "./BlogCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HomeBlog = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blog`).then((r) => setArticles(r.data.slice(0, 3))).catch(() => {});
  }, []);

  if (articles.length === 0) return null;

  return (
    <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-24" data-testid="home-blog">
      <div className="text-center mb-14">
        <p className="text-xs uppercase tracking-[0.35em] text-champagne mb-5">Centro Risorse</p>
        <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight leading-tight max-w-3xl mx-auto">
          Guide e Approfondimenti
        </h2>
        <p className="mt-6 max-w-2xl mx-auto text-foreground/70 font-light leading-relaxed">
          Consigli pratici, normativa e realizzazioni su vetrate panoramiche VEPA e pergole bioclimatiche.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {articles.map((a) => (
          <BlogCard key={a.slug} article={a} />
        ))}
      </div>

      <div className="flex justify-center mt-12">
        <Link
          to="/blog"
          data-testid="home-blog-cta"
          onClick={() => window.scrollTo({ top: 0 })}
          className="inline-flex items-center gap-2 border border-black px-8 py-4 text-sm uppercase tracking-wide hover:bg-black hover:text-white transition-colors duration-300"
        >
          Scopri tutte le guide <ArrowRight strokeWidth={1.2} className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
};
